import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, GoogleCalendarIntegration } from 'types';
import { client } from 'utils/api-client';

export default function useResyncGoogleCalendarIntegration(): UseMutationResult<
  AxiosResponse<GoogleCalendarIntegration>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const resyncGoogleCalendarIntegration = useCallback(
    (googleCalendarIntegrationId: string): Promise<AxiosResponse<GoogleCalendarIntegration>> => {
      return client.put(`google-calendar-integrations/${googleCalendarIntegrationId}/resync/`);
    },
    [],
  );

  return useMutation(resyncGoogleCalendarIntegration, {
    onSuccess: () => {
      queryClient.invalidateQueries(['google-calendar-integrations']);
      queryClient.invalidateQueries(['google-calendars']);
      queryClient.invalidateQueries(['google-calendars-autocomplete']);
    },
  });
}
